import { useEffect } from 'react';
import { showFeedback } from '../feedback/feedbackReducer';
import { useDispatch } from 'react-redux';
import { universalDocumentsApi } from '../apis';
import { downloadDocument } from './document/helper';
import { useSearchParams } from 'react-router-dom';
import { SearchParamKeys } from './searchParamKeys';

const useExportDownloader = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const exportId = Number(searchParams.get(SearchParamKeys.exportId));
    if (exportId) {
      dispatch(showFeedback({ message: `Downloading exported file...`, variant: 'success' }));

      universalDocumentsApi
        .downloadUniversalDocument({
          documentId: exportId,
        })
        .then((document) => {
          const filename = document.headers.get('Content-Disposition')?.split('filename=')[1];
          downloadDocument(document.body, filename ? filename : `export-${exportId}.csv`);
        });
    }

    setSearchParams(
      (prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.delete(SearchParamKeys.exportId);
        return newParams;
      },
      { replace: true }
    );
  }, []);
};

export default useExportDownloader;
